var React = require('react');

function TeamMembersPath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"team-members-path","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M4.7046301 4.7046301C25.02518309 68.37419586 85.32369548 182.65386528 259.76005912 215.981138c63.0418046 12.04457242 120.86260325 9.0171843 175.1706271-1.12163904C592.54194273 185.43488407 720.56648254 96.1134554 860.7600591 141.481138c188.5 61 224 330.5 370.5 352 113.64848485 16.67878788 186.07368228-16.8927089 212.84051-32.78770382"}));
}

TeamMembersPath.defaultProps = {"viewBox":"0 0 1448.805 502.717"};

module.exports = TeamMembersPath;

TeamMembersPath.default = TeamMembersPath;
